import { atomWithReset } from 'jotai/utils';
import { NetSuiteMatchingLine } from 'shared/hooks/(matchings)';

import { NetSuiteSourceMatchingLine } from './NetSuiteMatchingPopup.types';

export const netSuiteSourceMatchingLineState = atomWithReset<NetSuiteSourceMatchingLine | null>(null);

export const netSuiteTargetMatchingLineState = atomWithReset<NetSuiteMatchingLine | null>(null);
